import { render, staticRenderFns } from "./DepreciationManual.vue?vue&type=template&id=00f194a6"
import script from "./DepreciationManual.vue?vue&type=script&lang=js"
export * from "./DepreciationManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports